import type { StreamActivityStep } from '@/features/chat/hooks/useChat.types';
import { AnimatedThinkingLabel } from './AnimatedThinkingLabel';

/**
 * Live streaming activity timeline — hidden once text starts streaming.
 * Pure presentational leaf: renders the provided activity steps; the last
 * step animates via AnimatedThinkingLabel, earlier steps render a static dot.
 */
export function ThinkingTimeline({ steps }: { steps: StreamActivityStep[] }) {
  return (
    <div className="streaming-status-indicator">
      <div className="thinking-timeline" ref={(el) => { if (el) el.scrollTop = el.scrollHeight }}>
        {steps.map((step, index, arr) => {
          const isLast = index === arr.length - 1

          return (
            <div key={step.id} className={`thinking-step thinking-step--${step.type}${isLast ? ' is-active' : ''}`}>
              {!isLast && (
                <span className={`thinking-step-dot${step.type === 'tool_error' ? ' thinking-step-dot--error' : ''}`} aria-hidden="true" />
              )}
              {isLast ? (
                <AnimatedThinkingLabel text={step.label} />
              ) : (
                <span className="thinking-step-label">{step.label}</span>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
